const isAdmin = () => {
  const user = JSON.parse(localStorage.getItem('user') ? localStorage.getItem('user') : sessionStorage.getItem('user'));
  const permission = user.permission[0];
  return ('admin' === permission);
};
export {
  isAdmin
};
